import { CircularProgress, Stack } from "@mui/material"
import React from "react"

const LoadingContent = ({ loading, children }) => {
  return loading ? (
    <Stack alignItems={"center"} sx={{ py: 3 }}>
      <CircularProgress />
    </Stack>
  ) : (
    children
  )
}

export default LoadingContent
